import { Factory } from 'rosie';

Factory.define('TransactionDto').extend('Uuid');

Factory.define('CustomerTransactionDtoWithDefaults')
  .extend('TransactionDto')
  .attr('type', 'GENERIC')
  .attr('flightNo', '117')
  .attr('pnr', 'TSF72R');
